import { ExcludeOnPremURLS } from 'constants/app';

export function isBrandURL() {
  // For Prod
  const origin = window.location.origin;

  if (ExcludeOnPremURLS.includes(origin)) {
    return false;
  }
  // don't add any branding for dev url
  if (isDevURL()) {
    return false;
  }

  let domainParts = origin.split('.');

  if (!isStageURL()) {
    return domainParts[1] !== 'lambdatest';
  }

  // For Stage

  return domainParts[1] !== 'lambdatestinternal';
}

function isStageURL() {
  const origin = window.location.origin;

  if (origin.includes('//stage')) {
    return true;
  }

  return false;
}

function isDevURL() {
  const origin = window.location.origin;
  return origin.includes('dev') && origin.includes('lambdatestinternal');
}

function getBrandName() {
  const origin = window.location.origin;
  let domainParts = origin.split('.');

  return domainParts[1];
}

export function getBrandURL(url) {
  const domainParts = url.split('.');

  const brandName = getBrandName();

  domainParts.splice(1, 0, brandName);
  return domainParts.join('.');
}
